var Component = require("!./node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./node_modules/vue-loader/lib/selector?type=script&index=0!./Vue2LeafletMarkercluster.vue"),
  /* template */
  require("!!./node_modules/vue-loader/lib/template-compiler?id=data-v-4687b691!./node_modules/vue-loader/lib/selector?type=template&index=0!./Vue2LeafletMarkercluster.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./Vue2LeafletMarkercluster.vue
// module id = 0
// module chunks = 0